module.exports = __webpack_public_path__ + "static/media/Doremi Fantasy - English v1.1.73c1066c.zip";


//////////////////
// WEBPACK FOOTER
// ./src/files/Doremi Fantasy - English v1.1.zip
// module id = 182
// module chunks = 0